import React from "react";
import NotificationAlert from "react-notification-alert";
import Loader from "../../../Loader";
import {Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Row} from "reactstrap";
import AdminService from "../../../../services/adminService";
import FormInput from "../../../../components/common/form/FormInput";
import FormReactSelect from "../../../../components/common/form/FormReactSelect";
import DownloadUtil from "../../../../util/downloadUtil";
import UtilService from "../../../../services/utilService";
import countriesGlobal from "../../../../util/countriesGlobal";
import { companyType } from "../../../../util/companyType";


class Brand extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            errorData: {},
            alert: null,
            userId: "",
            loading: false,
            userCompanyName:"",
            brandWebsite: "",
            brandContactNumber: "",
            brandCountry: "",
            selectedBrandCountry: {},
            selectBrandCountryKey: UtilService.uuidv4(),
            companyType: "",
            selectedCompanyType: {},
            selectCompanyTypeKey: UtilService.uuidv4(),
            brandLogoUID:"",
            fileSelectUUID : UtilService.uuidv4()
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleBrandCountryChange = this.handleBrandCountryChange.bind(this);
        this.handleCompanyTypeChange = this.handleCompanyTypeChange.bind(this);
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    componentDidMount() {
        let userId = localStorage.getItem("userId")
        this.setState({userId: userId})
        this.loadUserData();
    }

    loadUserData = () => {
        let userId = localStorage.getItem("userId")
        AdminService.fetch(userId).then(response => {
            console.log(response.data)
            const brandCountry = response.data.brandCountry || "";
            const selectedCountry = brandCountry ? countriesGlobal.find(c => c.value === brandCountry) : null;
            const companyTypeValue = response.data.companyType || "";
            const selectedCompanyTypeObj = companyTypeValue ? companyType.find(c => c.value === companyTypeValue) : null;
            this.setState({
                userCompanyName: response.data.userCompanyName || "",
                brandWebsite: response.data.brandWebsite || "",
                brandContactNumber: response.data.brandContactNumber || "",
                brandCountry: brandCountry,
                selectedBrandCountry: selectedCountry,
                companyType: companyTypeValue,
                selectedCompanyType: selectedCompanyTypeObj,
                brandLogoUID: response.data.brandLogoUID
            });
        });
    }

    handleBrandCountryChange = (valueObj) => {
        if (!valueObj) {
            this.setState({selectedBrandCountry: null, brandCountry: ""});
        } else {
            this.setState({selectedBrandCountry: valueObj, brandCountry: valueObj.value});
        }
    }

    handleCompanyTypeChange = (valueObj) => {
        if (!valueObj) {
            this.setState({selectedCompanyType: null, companyType: ""});
        } else {
            this.setState({selectedCompanyType: valueObj, companyType: valueObj.value});
        }
    }

    changeBrandName = () => {
        let userCompanyName = this.state.userCompanyName
        let brandWebsite = this.state.brandWebsite
        let brandContactNumber = this.state.brandContactNumber
        let brandCountry = this.state.brandCountry
        let companyType = this.state.companyType

        let missingFields = [];

        if(missingFields.length > 0){
            this.notify("error", "Error", `The following fields are required: ${missingFields.join(", ")}`)
        } else {
            this.setState({loading:true})
            let data = {
                userCompanyName: userCompanyName,
                brandWebsite: brandWebsite,
                brandContactNumber: brandContactNumber,
                brandCountry: brandCountry,
                companyType: companyType,
                uniqueId: localStorage.getItem("userId")
            }
            console.log(data)
            AdminService.updateBrandName(data).then(response => {
                this.notify("success", "Success", "Brand details updated successfully!")
                this.loadUserData()
            }).catch(reason => {
                this.notify("error", "Error", "Something went wrong! Please try again later!")
            })
            this.setState({loading:false})
        }

    }

    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };

    hideAlert = () => {
        this.setState({
            alert: null
        });
    };

    fileChange = (event) => {
        this.setState({file: event.target.files[0]})
        console.log(this.state)
    };

    updateBrandLogo =(event) => {
        event.preventDefault();
        this.setState({loading: true})
        const data = new FormData()
        data.append('file', this.state.file)
        data.append('uniqueId', localStorage.getItem("userId"));
        console.log(data);
        AdminService.uploadLogo(data).then((response) => {
            console.log(response);
            if (response.responseStatus === "SUCCESS") {
                this.loadUserData()
                this.notify("success", "Upload Successful", "Brand Logo uploaded successfully!")
            } else {
                this.notify("danger", "Upload Unuccessful", "Brand Logo not uploaded successfully!")
                console.error("Error    ==>     " + response.message);
            }

            this.setState({loading: false})
        });
    }


    render() {
        return (
            <>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                {this.state.alert}
                {this.state.loading && <Loader/>}
                <Container className="mt--6" fluid>
                    <Card className="mb-4">
                        <CardHeader>
                            <h3 className="mb-0">Xare Trust Settings</h3>
                        </CardHeader>
                        <CardBody>
                            <Form role="form">
                                <Row>
                                    <Col md="12" sm="12" >
                                        <FormInput
                                            name="userCompanyName"
                                            className="form-control-label"
                                            id="userCompanyName"
                                            placeholder="Brand Name"
                                            type="text"
                                            onChange={this.handleChange}
                                            label="Brand Name"
                                            errorMsg={this.state?.errorObj?.userCompanyName || ""}
                                            value={this.state?.userCompanyName || ""}
                                            required
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" sm="12" >
                                        <FormInput
                                            name="brandWebsite"
                                            className="form-control-label"
                                            id="brandWebsite"
                                            placeholder="Brand Website"
                                            type="text"
                                            onChange={this.handleChange}
                                            label="Brand Website"
                                            errorMsg={this.state?.errorObj?.brandWebsite || ""}
                                            value={this.state?.brandWebsite || ""}

                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" sm="12" >
                                        <FormInput
                                            name="brandContactNumber"
                                            className="form-control-label"
                                            id="brandContactNumber"
                                            placeholder="Brand Contact Number"
                                            type="text"
                                            onChange={this.handleChange}
                                            label="Brand Contact Number"
                                            errorMsg={this.state?.errorObj?.brandContactNumber || ""}
                                            value={this.state?.brandContactNumber || ""}

                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" sm="12" >
                                        <FormReactSelect
                                            selectKey={this.state.selectBrandCountryKey}
                                            isMulti={false}
                                            className="form-control-label"
                                            isSearchable={true}
                                            label="Brand Country"
                                            name="brandCountry"
                                            onChange={this.handleBrandCountryChange}
                                            optionValue="value"
                                            value={this.state.selectedBrandCountry}
                                            optionList={countriesGlobal}
                                            optionLabel="key"
                                            placeHolder="Select Brand Country"
                                            errorMsg={this.state?.errorObj?.brandCountry || ""}

                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" sm="12" >
                                        <FormReactSelect
                                            selectKey={this.state.selectCompanyTypeKey}
                                            isMulti={false}
                                            className="form-control-label"
                                            isSearchable={true}
                                            label="Company Type"
                                            name="companyType"
                                            onChange={this.handleCompanyTypeChange}
                                            optionValue="value"
                                            value={this.state.selectedCompanyType}
                                            optionList={companyType}
                                            optionLabel="key"
                                            placeHolder="Select Company Type"
                                            errorMsg={this.state?.errorObj?.companyType || ""}

                                        />
                                    </Col>
                                </Row>
                                <div className="text-center">
                                    <Button outline className="my-4" color="default" type="button"
                                            onClick={() => this.changeBrandName()}
                                    >
                                        Update Details
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                    <Card className="mb-4">
                        <CardHeader>
                            <h3 className="mb-0">Brand Logo</h3>
                        </CardHeader>
                        <CardBody>
                            <Col md="6" sm="12">
                                <FormGroup>
                                    <br/>
                                    <span><img style={{width: "200px", height:"100px"}} src={DownloadUtil.generateUrl(this.state.brandLogoUID)} alt={"Brand Logo Not Uploaded"}/></span>
                                </FormGroup>
                            </Col>
                            <Col md="12" sm="12">
                                <Form role="form" onSubmit={this.updateBrandLogo}>
                                    <FormInput
                                        name="file"
                                        className="form-control-label custom-file-input"
                                        id="file"
                                        placeholder="inputPlaceHolder.notice.files"
                                        type="file"
                                        onChange={this.fileChange}
                                        label="Browse"
                                        multiple={false}
                                        key={this.state.fileSelectUUID}
                                        isEdit
                                        // value={this.props.valueObj.firstName || ""}
                                        // errorMsg={this.props.errorObj.firstName || ""}
                                    />
                                    <span
                                        className="badge badge-pill badge-primary">{this.state?.file?.name}</span>
                                    <div className="text-center">
                                        <Button className="my-4" color="default" outline type="submit">
                                            Update Details
                                        </Button>
                                    </div>
                                </Form>
                            </Col>
                        </CardBody>
                    </Card>



                </Container>
            </>
        )
    }
}

export default Brand;